import React from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Alert, Button } from "components/bootstrap";
import IndexRangeSummary from "components/indices/IndexRangeSummary";
import { INDICES_QUERY_KEY, reopenIndex, deleteIndex } from "hooks/useIndices";
const ClosedIndexDetails = ({ indexName, indexRange = void 0 }) => {
  const queryClient = useQueryClient();
  const _invalidate = () => queryClient.invalidateQueries({ queryKey: INDICES_QUERY_KEY });
  const _onReopen = () => {
    reopenIndex(indexName).then(_invalidate);
  };
  const _onDeleteIndex = () => {
    if (window.confirm(`Really delete index ${indexName}?`)) {
      deleteIndex(indexName).then(_invalidate);
    }
  };
  return /* @__PURE__ */ React.createElement("div", { className: "index-info" }, /* @__PURE__ */ React.createElement(IndexRangeSummary, { indexRange }), /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, "This index is closed. Index information is not available at the moment, please reopen the index and try again."), /* @__PURE__ */ React.createElement("hr", { style: { marginBottom: "5", marginTop: "10" } }), /* @__PURE__ */ React.createElement(Button, { bsStyle: "warning", bsSize: "xs", onClick: _onReopen }, "Reopen index"), " ", /* @__PURE__ */ React.createElement(Button, { bsStyle: "danger", bsSize: "xs", onClick: _onDeleteIndex }, "Delete index"));
};
export default ClosedIndexDetails;
